import styled from 'styled-components'
import { brandPalette as palette } from '../../styles/abstracts/_variables.styles'

export const PlanningSection = styled.section`
  width:min(118rem,calc(100% - 4rem)); margin:0 auto; padding:3.2rem 0;
  color:${palette.ink};
  h2,h3 { font-family:'Whyte-Bold',sans-serif; line-height:1.2; letter-spacing:-.025em; }
  h2 { font-size:clamp(2.6rem,3vw,3.6rem); margin:0 0 1.6rem; }
  h3 { font-size:2.2rem; margin:0 0 1rem; }
  p { font-size:1.7rem; line-height:1.7; max-width:72ch; margin:0 0 1.6rem; }
  a { text-decoration:underline; text-underline-offset:.3rem; }
  @media(max-width:767px){padding:2.4rem 0;}
  @media(max-width:359px){width:calc(100% - 3.2rem);}
`
export const GuideColumns = styled.div`
  display:grid; grid-template-columns:1fr 1fr; gap:2.4rem 4rem;
  @media(max-width:767px){grid-template-columns:1fr;gap:1.6rem;}
`
export const PlanningLinks = styled.div`
  display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); gap:1.2rem;
  a { display:block; padding:1.8rem; border:1px solid ${palette.seaGlass}; border-radius:.5rem; min-height:4.4rem; text-decoration:none; }
  a:hover { background:${palette.chalk}; }
  strong { display:block; font-size:1.8rem; text-decoration:underline; text-underline-offset:.3rem; }
  span { display:block; font-size:1.5rem; line-height:1.6; margin-top:.6rem; }
  @media(max-width:767px){grid-template-columns:1fr;}
`
